import { createAction, props } from '@ngrx/store';
import { IBusinessPaymentRunResponse } from '../dto/business-payment-run.dto';

export const loadBusinessPaymentRuns = createAction(
  '[BusinessPaymentRun] Load BusinessPaymentRuns',
  props<{ request: { businessId: string; businessPaymentRunId: string } }>()
);

export const loadBusinessPaymentRunsSuccess = createAction(
  '[BusinessPaymentRun] Load BusinessPaymentRuns Success',
  props<{ response: IBusinessPaymentRunResponse }>()
);

export const loadBusinessPaymentRunsFailure = createAction(
  '[BusinessPaymentRun] Load BusinessPaymentRuns Failure',
  props<{ error: Error | any }>()
);
